/* Patırtı arama paneli: <predictive-search>. Masaüstünde kutunun altında açılan panel + arka plan karartma,
   mobilde (≤767px) tam ekran arama katmanı (geri tuşuyla kapanır). Boşken geçmiş/popüler aramalar, yazınca
   Shopify Predictive Search önerileri (Section Rendering API: sections/predictive-search.liquid). */
(function () {
  'use strict';
  if (customElements.get('predictive-search')) return;
  const KEY = 'patirti_recent_searches';
  const MAX_HISTORY = 8;
  const MIN_CHARS = 2;
  const mobile = window.matchMedia('(max-width: 767px)');
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);

  const history$ = {
    read() {
      try {
        const data = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(data) ? data.filter(item => typeof item === 'string' && item.trim()).map(clean).slice(0, MAX_HISTORY) : [];
      } catch (_) { return []; }
    },
    write(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_HISTORY))); } catch (_) { /* gizli sekme */ } },
    add(term) {
      term = clean(term);
      if (!term) return;
      const low = term.toLocaleLowerCase('tr');
      this.write([term].concat(this.read().filter(item => item.toLocaleLowerCase('tr') !== low)));
    },
    remove(term) { this.write(this.read().filter(item => item !== term)); }
  };

  let backdrop = null;
  const getBackdrop = () => {
    if (backdrop && backdrop.isConnected) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'sp-backdrop';
    backdrop.hidden = true;
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    return backdrop;
  };

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = this.querySelector('[data-sp-form]');
      this.input = this.querySelector('[data-sp-input]');
      this.panel = this.querySelector('[data-sp-panel]');
      if (!this.form || !this.input || !this.panel) return;
      this.ready = true;
      this.emptyView = this.querySelector('[data-sp-empty]');
      this.resultsView = this.querySelector('[data-sp-results]');
      this.status = this.querySelector('[data-sp-status]');
      this.clearButton = this.querySelector('[data-sp-clear]');
      this.historyBox = this.querySelector('[data-sp-history]');
      this.historyList = this.querySelector('[data-sp-history-list]');
      this.cache = new Map();
      this.isOpen = false;
      this.pushed = false;
      this.pendingUrl = null;
      this.activeIndex = -1;
      this.uid = this.input.id || 'sp';
      this.lifetime = new AbortController();
      const on = (target, name, fn, options) => target.addEventListener(name, fn, Object.assign({ signal: this.lifetime.signal }, options));

      on(this.input, 'focus', () => { if (!this.restoring) this.open(); });
      on(this.input, 'click', () => this.open());
      on(this.input, 'input', () => { this.syncClear(); this.open(); this.schedule(); });
      on(this, 'keydown', event => this.onKey(event));
      on(this.form, 'submit', event => this.onSubmit(event));
      on(this, 'click', event => this.onClick(event));
      on(document, 'pointerdown', event => { if (this.isOpen && !mobile.matches && !this.contains(event.target)) this.close(false); });
      on(this, 'focusout', event => {
        if (!this.isOpen || mobile.matches) return;
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
      });
      on(window, 'popstate', () => {
        if (this.pushed) { this.pushed = false; this.close(false, true); }
        this.go();
      });
      on(window, 'pageshow', event => { if (event.persisted && this.isOpen) this.close(false); });
      /* Masaüstü mega menüsüne geçilince arama paneli kapanır (iki karartma üst üste binmesin). */
      on(document, 'pointerover', event => {
        if (this.isOpen && !mobile.matches && event.target.closest && event.target.closest('[data-mm-trigger]')) this.close(false);
      });
      on(mobile, 'change', () => { if (this.isOpen) this.close(false); });
      /* Katman açıkken sayfa yenilendiyse kalan geçmiş kaydını temizle. */
      try { if (history.state && history.state.patirtiSearch) history.replaceState(null, ''); } catch (_) { /* yok say */ }
      this.syncClear();
    }

    disconnectedCallback() {
      if (!this.ready) return;
      this.close(false);
      this.lifetime.abort();
      this.ready = false;
    }

    query() { return this.input.value.replace(/\s+/g, ' ').trim().slice(0, 200); }

    syncClear() { if (this.clearButton) this.clearButton.hidden = !this.input.value; }

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.classList.add('is-open');
      this.panel.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('sp-open');
      this.renderLazy();
      if (mobile.matches) {
        document.documentElement.classList.add('sp-open--mobile');
        document.body.classList.add('is-scroll-locked');
        try { history.pushState({ patirtiSearch: true }, ''); this.pushed = true; } catch (_) { this.pushed = false; }
      } else {
        const megaMenu = document.querySelector('mega-menu');
        if (megaMenu && typeof megaMenu.close === 'function') megaMenu.close();
        const layer = getBackdrop();
        layer.hidden = false;
        layer.onclick = () => this.close(false);
      }
      this.update();
    }

    close(restoreFocus = true, fromPopstate = false) {
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-open');
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-busy');
      this.setActive(-1);
      document.documentElement.classList.remove('sp-open', 'sp-open--mobile');
      document.body.classList.remove('is-scroll-locked');
      if (backdrop) backdrop.hidden = true;
      if (this.pushed && !fromPopstate) {
        this.pushed = false;
        if (history.state && history.state.patirtiSearch) history.back();
      }
      if (restoreFocus && !mobile.matches) {
        this.restoring = true;
        this.input.focus({ preventScroll: true });
        this.restoring = false;
      }
      else if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur();
    }

    /* Mobil katman geçmişe kayıt eklediyse önce o kaydı geri al, sonra hedefe git (geri tuşu temiz kalsın). */
    navigate(url) {
      if (this.pushed && history.state && history.state.patirtiSearch) {
        this.pendingUrl = url;
        this.pushed = false;
        history.back();
        setTimeout(() => this.go(), 400);
      } else {
        location.assign(url);
      }
    }

    go() {
      if (!this.pendingUrl) return;
      const url = this.pendingUrl;
      this.pendingUrl = null;
      location.assign(url);
    }

    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.update(), 200);
    }

    update() {
      const query = this.query();
      this.setActive(-1);
      if (query.length < MIN_CHARS) {
        if (this.controller) this.controller.abort();
        this.input.removeAttribute('aria-busy');
        this.showView(false);
        this.renderHistory();
        return;
      }
      this.fetchResults(query);
    }

    showView(results) {
      this.emptyView.hidden = results;
      this.resultsView.hidden = !results;
      this.classList.toggle('has-results', results);
    }

    async fetchResults(query) {
      if (this.cache.has(query)) { this.renderResults(this.cache.get(query), query); return; }
      if (this.controller) this.controller.abort();
      const controller = this.controller = new AbortController();
      let timedOut = false;
      const timeout = setTimeout(() => { timedOut = true; controller.abort(); }, 8000);
      const url = new URL(this.dataset.url || '/search/suggest', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('section_id', this.dataset.section || 'predictive-search');
      url.searchParams.set('resources[type]', 'query,collection,product');
      url.searchParams.set('resources[limit]', this.dataset.limit || '6');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      this.input.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('search ' + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('[data-sp-results-content]');
        if (!content) throw new Error('search markup');
        if (this.cache.size > 30) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(query, content.outerHTML);
        if (controller === this.controller && this.isOpen && this.query() === query) this.renderResults(content.outerHTML, query);
      } catch (error) {
        if (error.name === 'AbortError' && !timedOut) return;
        if (this.isOpen && this.query() === query) this.renderError(query);
      } finally {
        clearTimeout(timeout);
        if (controller === this.controller) this.input.removeAttribute('aria-busy');
      }
    }

    renderResults(markup, query) {
      if (!this.isOpen || this.query() !== query) return;
      this.resultsView.innerHTML = markup;
      this.showView(true);
      this.resultsView.scrollTop = 0;
      this.panel.scrollTop = 0;
      const content = this.resultsView.firstElementChild;
      const count = Number(content && content.dataset.count) || 0;
      this.announce(count ? (this.dataset.strResults || '__COUNT__').replace('__COUNT__', count) : (this.dataset.strNone || ''));
    }

    renderError(query) {
      const link = document.createElement('a');
      link.className = 'sp-all';
      link.href = this.searchUrl(query);
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      link.dataset.spOption = '';
      link.dataset.spAll = '';
      link.textContent = (this.dataset.strAll || '__TERMS__').replace('__TERMS__', query);
      const note = document.createElement('p');
      note.className = 'sp-none';
      note.textContent = this.dataset.strError || '';
      const wrap = document.createElement('div');
      wrap.className = 'sp-results';
      wrap.append(note, link);
      this.resultsView.replaceChildren(wrap);
      this.showView(true);
      this.announce(note.textContent);
    }

    renderHistory() {
      if (!this.historyList) return;
      const base = this.historyList.dataset.base || '/search?q=';
      const items = history$.read();
      const nodes = items.map(term => {
        const li = document.createElement('li');
        li.className = 'sp-chip sp-chip--history';
        li.setAttribute('role', 'presentation');
        const link = document.createElement('a');
        link.href = base + encodeURIComponent(term);
        link.textContent = term;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        link.dataset.spOption = '';
        link.dataset.spTerm = term;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sp-chip__remove';
        remove.dataset.spRemove = term;
        remove.setAttribute('aria-label', (this.dataset.strRemove || '') + ': ' + term);
        remove.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="m5 5 14 14M19 5 5 19"/></svg>';
        li.append(link, remove);
        return li;
      });
      this.historyList.replaceChildren(...nodes);
      if (this.historyBox) this.historyBox.hidden = !nodes.length;
    }

    renderLazy() {
      this.querySelectorAll('template[data-sp-lazy]').forEach(template => {
        const target = template.parentElement.querySelector('[data-sp-lazy-target]');
        if (target && !target.childElementCount) target.appendChild(template.content.cloneNode(true));
      });
    }

    searchUrl(query) {
      const url = new URL(this.dataset.searchUrl || '/search', location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('type', 'product');
      return url.href;
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      setTimeout(() => { this.status.textContent = message; }, 60);
    }

    options() {
      const view = this.resultsView.hidden ? this.emptyView : this.resultsView;
      return Array.from(view.querySelectorAll('[data-sp-option]')).filter(node => node.getClientRects().length);
    }

    setActive(index) {
      const options = this.options();
      this.querySelectorAll('[data-sp-option].is-active').forEach(node => { node.classList.remove('is-active'); node.setAttribute('aria-selected', 'false'); });
      this.activeIndex = index;
      const target = options[index];
      if (!target) { this.input.removeAttribute('aria-activedescendant'); this.activeIndex = -1; return; }
      if (!target.id) target.id = this.uid + '-opt-' + Math.random().toString(36).slice(2, 8);
      target.classList.add('is-active');
      target.setAttribute('aria-selected', 'true');
      this.input.setAttribute('aria-activedescendant', target.id);
      target.scrollIntoView({ block: 'nearest' });
    }

    onKey(event) {
      if (event.key === 'Escape') {
        if (!this.isOpen) return;
        event.preventDefault();
        this.close(true);
        return;
      }
      if (event.target !== this.input) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!this.isOpen) this.open();
        const options = this.options();
        if (!options.length) return;
        const step = event.key === 'ArrowDown' ? 1 : -1;
        let next = this.activeIndex + step;
        if (next >= options.length) next = -1;
        if (next < -1) next = options.length - 1;
        this.setActive(next);
        return;
      }
      if (event.key === 'Enter' && this.isOpen && this.activeIndex > -1) {
        const target = this.options()[this.activeIndex];
        if (target) { event.preventDefault(); target.click(); }
      }
    }

    onSubmit(event) {
      const query = this.query();
      event.preventDefault();
      if (!query) { this.input.focus(); return; }
      history$.add(query);
      this.navigate(this.searchUrl(query));
    }

    onClick(event) {
      const back = event.target.closest('[data-sp-back]');
      if (back) { event.preventDefault(); this.close(false); return; }
      const clear = event.target.closest('[data-sp-clear]');
      if (clear) {
        event.preventDefault();
        this.input.value = '';
        this.syncClear();
        this.input.focus();
        if (!this.isOpen) this.open(); else this.update();
        return;
      }
      if (event.target.closest('[data-sp-clear-history]')) {
        history$.write([]);
        this.renderHistory();
        this.input.focus({ preventScroll: true });
        return;
      }
      const remove = event.target.closest('[data-sp-remove]');
      if (remove) {
        event.preventDefault();
        history$.remove(remove.dataset.spRemove);
        this.renderHistory();
        this.input.focus({ preventScroll: true });
        return;
      }
      const link = event.target.closest('a[href]');
      if (!link || !this.panel.contains(link)) return;
      if (link.dataset.spTerm) history$.add(link.dataset.spTerm);
      else if (this.query()) history$.add(this.query());
      if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      let url;
      try { url = new URL(link.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      if (this.pushed) { event.preventDefault(); this.navigate(url.href); }
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
})();
